
dre.core.main();